export const GOOGLE_CLIENT_ID: string | null =
  typeof window !== 'undefined' && window.env?.GOOGLE_CLIENT_ID;
export const IMGIX_ENV: string | null =
  typeof window !== 'undefined' && (window.env?.IMGIX_ENV || window.env?.RAILS_ENV);
export const IMGIX_URL: string | null = typeof window !== 'undefined' && window.env?.IMGIX_URL;
export const RAILS_ENV: string | null = typeof window !== 'undefined' && window.env?.RAILS_ENV;
export const READ_ONLY_MODE: string | null =
  typeof window !== 'undefined' && window.env?.READ_ONLY_MODE;
export const READ_ONLY_PHRASE: string | null =
  typeof window !== 'undefined' && window?.env?.READ_ONLY_PHRASE;
export const READER_URL: string | null = typeof window !== 'undefined' && window.env?.READER_URL;
export const RECAPTCHA_SITE_KEY: string =
  typeof window !== 'undefined' && window.env?.RECAPTCHA_SITE_KEY;
export const SHOW_MODAL_ON_INACTION_SECONDS: number =
  typeof window !== 'undefined' && parseInt(window.env?.SHOW_MODAL_ON_INACTION_SECONDS || '31000');
export const STRIPE_PUBLISH_KEY: string | null =
  typeof window !== 'undefined' && window.env.STRIPE_PUBLISH_KEY;
export const SUBSCRIPTIONS_URL: string | null =
  typeof window !== 'undefined' && window.env.SUBSCRIPTIONS_URL;
